module.exports = __webpack_public_path__ + "static/img/banner@2x.c24a31a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fy/banner@2x.png
// module id = SRA2
// module chunks = 1